import { render, staticRenderFns } from "./RolePermissionExplorer.vue?vue&type=template&id=f934deb6&scoped=true"
import script from "./RolePermissionExplorer.vue?vue&type=script&lang=js"
export * from "./RolePermissionExplorer.vue?vue&type=script&lang=js"
import style0 from "./RolePermissionExplorer.vue?vue&type=style&index=0&id=f934deb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f934deb6",
  null
  
)

export default component.exports